import React, { Component } from 'react';
import { connect } from 'react-redux';
import { adminGetFolderLogs, resetLogs } from 'services/log';
import { searchFolders } from 'services/folder';
import moment from 'moment';
import { Grid, Button, Card, Dimmer, Loader, Icon } from 'semantic-ui-react';
import AsyncSelect from 'react-select/async';
import 'react-vertical-timeline-component/style.min.css';
import 'styles/timeline.css';
import debounce from 'debounce-promise';
import LogTimeline from 'components/LogTimeline';
import {Form,Formik,Field} from 'formik';
import { Checkbox } from 'features/FolderManager/components/Questions/components/Form/SpecialButtons';
import FolderManager from '../../FolderManager/index'

class Logs extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedFolder: null,
			searchTerm:'',
			seeFolder: false,
			logsFolder: false
		};
	}

	componentDidMount() {
		this.props.resetLogs();
		this.props.searchFolders();
	}

	filterFolders = debounce((options, searchTerm) => {
		if ( searchTerm)
			this.setState({searchTerm:searchTerm})
		if (this.state.searchTerm && !searchTerm )
			searchTerm = this.state.searchTerm
		return new Promise((resolve, reject) => {
			this.props
				.searchFolders(searchTerm, options)
				.then(() => resolve(this.foldersOptions()))
				.catch((error) => reject(error));
		});
	}, 500);

	foldersOptions = () =>
		this.props.folderManager.searchedFolders.map((folder) => ({
			label: `Dossier ${folder.code} - ${folder.patientName} - ${moment(
				folder.date
			).format(process.env.REACT_APP_DATE_DISPLAY_FORMAT)}`,
			value: folder.id,
		}));

	render() {
		const { logs, adminGetFolderLogs } = this.props;
		const { selectedFolder,seeFolder, logsFolder } = this.state;
		
		return (
			<div
				className='ui container'
				style={{ maxHeight: '100vh', display: 'flex' }}
			>
				<Dimmer active={logs.loading}>
					<Loader />
				</Dimmer>
				<Card
					style={{
						margin: '63px 0 20px 0',
						width: '100%',
					}}
				>
					<Card.Content>
						<Grid>
							<Grid.Row></Grid.Row>
							<Grid.Row>
								<Grid.Column
									mobile={8}
									tablet={8}
									computer={8}
									style={{
										display: 'flex',
										alignContent: 'center',
										alignItems: 'center',
									}}
								>
									Filtrer les dossiers
								</Grid.Column>
								<Grid.Column
									mobile={8}
									tablet={8}
									computer={8}
									style={{ display: 'flex', justifyContent: 'flex-end' }}
								>
									<Button
										icon='refresh'
										inverted
										color='green'
										disabled={selectedFolder === null}
										onClick={() =>{ adminGetFolderLogs(selectedFolder); this.setState({seeFolder:false}); this.setState({logsFolder:[selectedFolder]})}}
									/>
									<div data-tooltip="Visualiser le dossier" data-position="bottom left">
										<Button
											color='blue'
											disabled={selectedFolder === null}
											onClick={() => {this.setState({seeFolder:true}); this.setState({logsFolder:[selectedFolder]}) }}
										><Icon name='browser' /> Voir</Button>
									</div>
								</Grid.Column>
								<Grid.Column mobile={16} tablet={16} computer={16}>
									<Formik
										initialValues={{
											inFolder: true,
											inPrescription: true,
											inPatientCNS: true,
											inPatientName: true,
											inPatientFirstName: true,
											inTube: true,
											inDocument: true,
										}}
										onSubmit={(values) => {
											this.filterFolders(values); 
										}}
									>
										{({values}) => (
											<Form>
												<span style={{fontStyle: 'italic'}}>
												<div>
														<div id="checkbox-group">Filtres possibles: </div>
														<div style={{ display: 'flex', flex: 1, flexDirection: 'row', marginBottom:'20px' }}>
														<Field
															customlabel="Dossier"
															component={Checkbox}
															name="inFolder"
															id="inFolder"
															label="inFolder"
															style={{marginTop:0}}
														/>
														<Field
															customlabel="Prescription"
															component={Checkbox}
															name="inPrescription"
															id="inPrescription"
															label="inPrescription"
															style={{marginTop:0}}
														/>
														<Field
															customlabel="Patient CNS"
															component={Checkbox}
															name="inPatientCNS"
															id="inPatientCNS"
															label="inPatientCNS"
															style={{marginTop:0}}
														/>
														<Field
															customlabel="Nom du patient"
															component={Checkbox}
															name="inPatientName"
															id="inPatientName"
															label="inPatientName"
															style={{marginTop:0}}
														/>

														<Field
															customlabel="Prénom du patient"
															component={Checkbox}
															name="inPatientFirstName"
															id="inPatientFirstName"
															label="inPatientFirstName"
															style={{marginTop:0}}
														/>

														<Field
															customlabel="Tube"
															component={Checkbox}
															name="inTube"
															id="inTube"
															label="inTube"
															style={{marginTop:0}}
														/>

														<Field
															customlabel="Document"
															component={Checkbox}
															name="inDocument"
															id="inDocument"
															label="inDocument"
															style={{marginTop:0}}
														/>
														</div>

													</div>
												</span>
												<AsyncSelect
													onChange={(option) => {
														if (option) {
															adminGetFolderLogs(option.value);
															this.setState({
																selectedFolder: option.value,
															});
															this.setState({seeFolder:false});
														}
													}}
													defaultOptions={this.foldersOptions()}
													placeholder='Sélectionner un dossier'
													loadOptions={(value) => this.filterFolders( values, value)}
													noOptionsMessage={() => 'Aucun résultat'}
													loadingMessage={() => 'Chargement...'}
													isClearable
									/>
											</Form>
										)}
									</Formik>
								</Grid.Column>
							</Grid.Row>
						</Grid>
					</Card.Content>
					<Card.Content style={{ overflowY: 'scroll' }}>
						{seeFolder ? <FolderManager logsFolder = {logsFolder} />: <LogTimeline logs={logs} />}
					</Card.Content>
				</Card>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		logs: state.logs,
		folderManager: state.folderManager,
	};
};

const mapDispatchToProps = {
	adminGetFolderLogs,
	searchFolders,
	resetLogs,
};

export default connect(mapStateToProps, mapDispatchToProps)(Logs);
